export enum Country {
  Norway = 'NO',
  Sweden = 'SE',
}
